import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { components } from '@blaze-cms/react-page-builder';

const { code: CodeComponent } = components;

const ProductDetailsModal = ({ modalContent, hideModal }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside({ target }) {
      const shouldHideFlyOut = wrapperRef.current && !wrapperRef.current.contains(target);
      if (shouldHideFlyOut) hideModal();
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [hideModal, wrapperRef]);

  return (
    <div className="kp-product-details__modal-overlay">
      <div className="kp-product-details__modal-overlay__modal" ref={wrapperRef}>
        <div
          className="kp-product-details__modal-overlay__modal__header"
          role="presentation"
          onClick={hideModal}>
          <i className="fas fa-close" />
        </div>
        <div className="kp-product-details__modal-overlay__modal__content">
          <CodeComponent code={modalContent} />
        </div>
      </div>
    </div>
  );
};

ProductDetailsModal.propTypes = {
  modalContent: PropTypes.string.isRequired,
  hideModal: PropTypes.func.isRequired
};

export default ProductDetailsModal;
